import { Client } from '@/api';
import { Settings, SettingsFromServerData } from '@/lib/trashsim/settings';
import { NewFleetFromAPI, NewFleetFromAPIString, NewFleetFromAPIJson } from '@/lib/trashsim/fleet';
import type { Fleet } from '@/lib/trashsim/fleet';

const api = new Client('https://trashsim.oplanet.eu')

function LoadAPI(key: string | null, isDefender: boolean): Promise<{ fleet: Fleet, settings?: Settings }> {
    if (key == null) {
        return Promise.reject('invalid api key')
    }

    // use an api key
    if (/sr-[a-z]{2}-[\d]{1,3}-[a-f0-9]{40}/.test(key)) {
        api.spy(key).then(report => {
            let fleet = NewFleetFromAPI(report, isDefender)
            fleet.API = key
            const settings = SettingsFromServerData(report.server, report.loot_percentage)
            return { fleet, settings }
        })
    }

    // use fleet key version 1
    else if (/coords;\d:[\d]{1,3}:[\d]{1,2}\|characterClassId;\d\|[\d\|;]+/.test(key)) {
        const fleet = NewFleetFromAPIString(key, isDefender)
        fleet.API = key

        return new Promise((resolve) => {
            resolve({ fleet })
        })
    }

    // use fleet key version 2
    try {
        const fleet = NewFleetFromAPIJson(key, isDefender)
        fleet.API = key
        
        return new Promise((resolve) => {
            resolve({ fleet })
        })
    } catch {

    }
    
    return Promise.reject('invalid api key')
}

export {
    LoadAPI
}